// StepOne.tsx
import React from "react";
import TextInput from "../../../ReusableInputs/TextInput";
import TextAreaInput from "../../../ReusableInputs/TextAreaInput";
import { labelStyle } from "../../../../@types/productInfo";

interface StepOneProps {
  title: string;
  image:string;
  bloglink:string;
  setTitle: (value: string) => void;
  setBlogLink: (value: string) => void;
  metaTitle: string;
  setMetaTitle: (value: string) => void;
  metaDescription: string;
  setMetaDescription: (value: string) => void;
  selectedFileImage: File | null;
  setSelectedFileImage: (file: File | null) => void;
  handleFileChangeImage: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const StepOne: React.FC<StepOneProps> = ({
  title,
  setTitle,
  metaTitle,
  setMetaTitle,
  metaDescription,
  setMetaDescription,
  selectedFileImage,
  setSelectedFileImage,
  handleFileChangeImage,
  bloglink,
  setBlogLink,
  image
  // 
}) => {
  return (
    <div className="flex space-x-4">
    <div className="bg-white p-4 rounded-md w-[60%] mt-[-10px]">
      <div>
        <div>
          <div>
            <div className="border-gray-300 border p-4 rounded-sm">
              <section className="flex flex-col md:flex-row md:space-x-4 w-full">
                <div className="w-1/2 p-2">
                  <TextInput
                    title="Blog Title"
                    inputValue={title}
                    setInputValue={setTitle}
                    placeholder="Enter Blog Title"
                  />
                </div>
                <div className="w-1/2 p-2">
                  <TextInput
                    title="Blog URL"
                    inputValue={bloglink}
                    setInputValue={setBlogLink}
                    placeholder="Enter Blog Url"
                  />
                </div>
              </section>
              <section className=" md:space-x-4 w-full">
                <div className=" p-2">
                  <TextInput
                    title="Blog Meta Title"
                    inputValue={metaTitle}
                    setInputValue={setMetaTitle}
                    placeholder="Enter Blog Meta Title"
                  />
                </div>
                
              </section>

              <TextAreaInput
                inputValue={metaDescription}
                setInputValue={setMetaDescription}
                title="Meta Description"
                placeholder="Enter Meta Description"
              />
            </div>

           
          </div>
        </div>
      </div>
    </div>

    <div className="bg-white rounded-md w-[35%] relative h-[150px] mt-[-10px]  
     ">
     
      <div className=" w-[full] justify-between  ">
      
     <div className="mb-[20px] mt-[17px] font semi-bold">
     <label
            style={labelStyle as React.CSSProperties}
          
            className="color-[#005D6E] font semi-bold mb-[20px]">
            Upload Blog Banner
          </label>
     </div>
        <div className=" justify-center  w-full ">
           
          
          <label
            htmlFor="dropzone-file-1"
            className="flex flex-col items-center  justify-center w-full h-[110px] 
              border-2 border-gray-300 border-dashed rounded-lg cursor-pointer bg-gray-50
            dark:bg-gray-700 hover:bg-gray-100 dark:border-gray-600 dark:hover:border-gray-500
             dark:hover:bg-gray-600">
            <div className="flex flex-col items-center justify-center ">
             
               
              <svg
                className="w-6 h-6 mb-2 text-gray-500 dark:text-gray-400"
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 20 16">
                <path
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M13 13h3a3 3 0 0 0 0-6h-.025A5.56 5.56 0 0 0 16 6.5 5.5 5.5 0 0 0 5.207 5.021C5.137 5.017 5.071 5 5 5a4 4 0 0 0 0 8h2.167M10 15V6m0 0L8 8m2-2 2 2"
                />
              </svg>
              <p className="mb-1 text-gray-500  dark:text-gray-400">
                <span className="font-semibold">Click to upload</span>{" "}
                or drag and drop image
              </p>
            </div>
            <input
              id="dropzone-file-1"
              type="file"
              accept="image/*"
              onChange={handleFileChangeImage}
              className="hidden"
            />
          </label>
        </div>

        <div className=" w-full  ">
            {selectedFileImage ? <div>
              <label
                style={labelStyle as React.CSSProperties}
                htmlFor="image"
                className="text-gray-600 font-bold text-sm mt-[15px]">
                Preview Image
              </label>
              <label className=" w-[full] h-40  mt-[60px]   rounded  ">
                <div className="w-[full] h-[110px] rounded ">
                  <div className="p-4 w-full">
                    <div className="w-auto mt-[5%]">
                      <div className=" py-0 rounded justify-center mt-8">
                        <img
                          src={
                            URL.createObjectURL(selectedFileImage) || image
                          }
                          alt=""
                          style={{
                            width: "auto",
                           
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                
              </label>
            </div> : <div>
              <label
                style={labelStyle as React.CSSProperties}
                htmlFor="image"
                className="text-gray-600 font-bold text-sm mt-[15px]">
                Preview Image
              </label>
              <label className=" w-[full] h-40  mt-[60px]   rounded  ">
                <div className="w-[full] h-[110px] rounded ">
                  <div className="p-4 w-full">
                    <div className="w-auto mt-[5%]">
                      <div className=" py-0 rounded justify-center mt-8">
                        <img
                          src={
                             image
                          }
                          alt=""
                          style={{
                            width: "auto",
                           
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                
              </label>
            </div>}
          
        </div>
      </div>
    </div>
  </div>
  );
};

export default StepOne;
